import { Typography } from '@mui/material';
import { usePaymentTypeLabels } from '../../transactions.hooks';

const TypeCell = ({ params }) => {
  const TypeLabels = usePaymentTypeLabels();
  return <Typography>{TypeLabels[params.value]}</Typography>;
};

export default TypeCell;
